var C = /* @__PURE__ */ ((e) => (e.fill = "fill", e.outline = "outline", e))(C || {}), m = /* @__PURE__ */ ((e) => (e.md = "md", e.sm = "sm", e))(m || {}), f = /* @__PURE__ */ ((e) => (e.default = "default", e.strong = "strong", e))(f || {}), g = /* @__PURE__ */ ((e) => (e.rounded = "rounded", e.squared = "squared", e))(g || {});
const I = (e) => {
  switch (e) {
    case "fill":
      return "chip-input-fill";
    case "outline":
      return "chip-input-outline";
    default:
      return "";
  }
}, v = (e) => {
  switch (e) {
    case "sm":
      return "chip-input-sm";
    case "md":
      return "chip-input-md";
    default:
      return "";
  }
}, $ = (e) => {
  switch (e) {
    case "strong":
      return "chip-input-strong";
    case "default":
      return "";
    default:
      return "";
  }
}, b = (e) => {
  switch (e) {
    case "squared":
      return "chip-input-squared";
    case "rounded":
      return "";
    default:
      return "";
  }
}, w = (e) => {
  switch (e) {
    case "sm":
      return 12;
    case "md":
      return 14;
    default:
      return 14;
  }
}, q = (e) => {
  const { variant: t, size: s, emphasis: n, shape: r, disabled: u, closable: a } = e, i = I(t), c = v(s), d = $(n), l = b(r), p = a ? "chip-input-close" : "", o = u ? "chip-input-disabled" : "", h = e.prependedEmoji || e.prependedIcon || e.prependedAvatar ? "chip-input-prepended" : "";
  return `chip-input ${i} ${c} ${d} ${l} ${p} ${o} ${h}`;
};
export {
  f as EChipEmphasis,
  g as EChipShapes,
  m as EChipSizes,
  C as EChipVariants,
  w as getInputChipPrependedIconSize,
  q as getInputChipStyleClasses
};
